import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  affiliates: [],
  activeAffiliates: [],
  countryInput: "",
  countryCode: "",
  affiliateError:"",
  status: "",
  totalNumberOfAffiliates: "",
  affiliatePage: 1,
  affiliateIsLoading: true,
  isAffiliaeCreating: false,
  currentPage: 1,
  totalPages: null,
  affliliatDetails: [],
};

const affiliateSlice = createSlice({
  name: "affiliate",
  initialState,
  reducers: {
    setIsAffiliateCreating(state, action) {
      state.isAffiliaeCreating = action.payload.isAffiliaeCreating;
    },
    setIsAffiliateLoading(state, action) {
      state.affiliateIsLoading = action.payload.affiliateIsLoading;
    },
    getAffiliate: (state, action) => {
      state.affiliates = action.payload.affiliates;
    },
    setCountryInput: (state, action) => {
      state.countryInput = action.payload.countryInput;
    },
    setCountryCode: (state, action) => {
      state.countryCode = action.payload.countryCode;
    },
    setAffiliateError: (state, action) => {
      state.affiliateError = action.payload.affiliateError;
    },
    setStatus: (state, action) => {
      state.status = action.payload.status;
    },
    getTotalnumberOfAffiliates: (state, action) => {
      state.totalNumberOfAffiliates = action.payload.totalNumberOfAffiliates;
    },
    getAllActiveAffiliates: (state, action) => {
      state.activeAffiliates = action.payload.activeAffiliates;
    },

    setAffiliatePreviousPage: (state) => {      
      state.currentPage -= 1;
    },
    setAffiliateNextPage: (state) => { 
      state.currentPage += 1;
    },
    setAffiliatePageNumber: (state, action) => {
      const pageNumber = action.payload;
      state.currentPage = pageNumber;
    },
    setTotalPage: (state, action) => {
      state.totalPages = action.payload.totalPages
    },
  },
});

export const {
  setIsAffiliateCreating,
  setIsAffiliateLoading,
  getAffiliate,
  setCountryInput,
  setStatus,
  setAffiliateError,
  getTotalnumberOfAffiliates,
  getAllActiveAffiliates,
  setCountryCode,
  setAffiliatePreviousPage,
  setAffiliateNextPage,
  setAffiliatePageNumber,
  setAffiliateData,
  setTotalPage
} = affiliateSlice.actions;
export const affiliateReducer = affiliateSlice.reducer;
